import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"


const submit = async ({
  userFolioSelected,
  userSelected,
  usersToDelete
}: {
  userFolioSelected: Record<
    string,
    {
      webAccess?: boolean
      mobileAccess?: boolean
      seeReport?: boolean
      resendReport?: boolean
    }
  >
  userSelected: Record<string, boolean>,
  usersToDelete: number[]
}) => {
  let body: {
    users: {
      accessWeb: boolean,
      accessMobile: boolean,
      accessShowReport: boolean,
      accessResendReport: boolean,
      userId: number
    }[],
    deletes: number[]
  } = {
    users: [],
    deletes: []
  }

  const users = Object.entries(userFolioSelected)

  body = {
    users: users?.filter(([key]) => !!userSelected[key])?.map(([key, itemUser]) => {
      const accessWeb = itemUser?.webAccess ?? false
      const accessMobile = itemUser?.mobileAccess ?? false
      const accessShowReport = itemUser?.seeReport ?? false
      const accessResendReport = itemUser?.resendReport ?? false

      return {
        userId: parseInt(key),
        accessWeb: accessWeb,
        accessMobile: accessMobile,
        accessShowReport: accessShowReport,
        accessResendReport: accessResendReport,
      }
    }),
    deletes: usersToDelete

  }

  // return true
  return await loogbookServiceFetch.updateAccess(body)
}

export { submit }
